export const timestampFormatDateTime = (ts: number, mult: number = 1): string => {
	return new Date(ts * mult).toLocaleString();
};

export const timestampFormatTime = (ts: number, mult: number = 1): string => {
	return new Date(ts * mult).toLocaleString("default", {
		hour: "numeric",
		minute: "2-digit",
	});
};

export const timestampFormatDate = (ts: number, mult: number = 1): string => {
	return new Date(ts * mult).toLocaleDateString();
};
